import styled from 'styled-components';
import React from 'react';
import PropTypes from 'prop-types';
import { green } from '../../styles/constants';

const StepNumber = styled.div`
  width: 2.2rem;
  height: 2.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: white;
  border: 2px solid ${green};
  color: ${green};
  font-weight: 600;
  font-size: 1.2rem;
`;

const StepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
`;

const StepImageWrapper = styled.div`
  height: 200px;
  display: flex;
`;

const StepImage = styled.img`
  height: auto;
  width: 100%;
`;

const StepHeading = styled.span`
  font-weight: 600;
  color: ${green};
`;

const StepHr = styled.hr`
  border-top: 3px solid ${green};
  width: 30px;
`;

const StepText = styled.span`
  opacity: 0.9;
`;

const Step = ({
  number, image, heading, text,
}) => (
  <StepWrapper>
    <StepNumber>{number}</StepNumber>
    <StepImageWrapper>
      <StepImage src={image} alt="step" />
    </StepImageWrapper>
    <StepHeading>{heading}</StepHeading>
    <StepHr />
    <StepText>{text}</StepText>
  </StepWrapper>
);

Step.propTypes = {
  number: PropTypes.number.isRequired,
  image: PropTypes.node.isRequired,
  heading: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default Step;
